<template>

    <div class="container">
        <div class="back_left" @click="$router.back()" />
        <div class="headers">
            <img class="logo" src="../images/login/Snipaste2.png" alt="logo" />
            <span class="title">国家开发银行</span>
        </div>

        <div class="main-title">邀请好友 领取现金</div>

        <div class="invitation-code-box">
            <div class="code-left">
                <img loading="lazy" class="qrcode" :src="data.share_image_url" alt="">
            </div>
            <div class="code-right">
                <div class="code-display">我的邀请码:{{ data.invitation_code }}</div>
                <div class="code-btn">
                    <button @click="copyCode" class="btn">复制邀请码</button>
                    <button @click="copyLink" class="btn">复制推广链接</button>
                </div>
            </div>
        </div>

        <div class="rules">
            <h3 style="color: black;display: flex;"><img style="width: 20px;margin-right: 10px;"
                    src="../images/user/team/bazi.png" alt="">活动规则</h3>
            <ul>
                <li>注册送<span class="highlight">50000</span>元现金，额外获得<span class="highlight">10000</span>资金追回额度</li>
                <li>每邀请一人送<span class="highlight">10000</span>现金，额外获得<span class="highlight">5000</span>资金追回额度</li>
                <div class="fontyc">以此类推,上不封顶</div>
                <li>报名领取<span class="highlight">100000</span>现金，<span class="highlight">20000</span>资金追回额度，签到奖励<span
                        class="highlight">2000</span>现金</li>
            </ul>
        </div>

        <div class="invite-friends">
            <h3 style="color: black;display: flex;"><img style="width: 20px;margin-right: 10px;"
                    src="../images/user/team/home3.png" alt="">邀请好友</h3>

            <ul>
                <li>邀请好友达到10人即可<p>获得<span class="highlight">200000</span>现金奖励，<span class="highlight">50000</span>资金追回额度
                    </p>
                </li>
                <li>邀请好友达到20人即可<p>获得<span class="highlight">500000</span>现金奖励，<span
                            class="highlight">100000</span>资金追回额度
                    </p>
                </li>
                <li>邀请好友达到50人即可<p>获得<span class="highlight">1000000</span>现金奖励，<span
                            class="highlight">250000</span>资金追回额度
                    </p>
                </li>
                <li>邀请好友达到100人即可<p>获得<span class="highlight">2000000</span>现金奖励，<span
                            class="highlight">500000</span>资金追回额度
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import Vue from 'vue';
import {
    Empty
} from 'vant';
import Clipboard from "v-clipboard";
Vue.use(Empty).use(Clipboard);
export default {
    name: "InvitePage",
    data() {
        return {
            data: {},
            invitationCode: "154112",
            promotionLink: "https://example.com/register?code=154112"
        };
    },
    created() {
        this.$parent.footer('user', false);
        this.start();
    },
    mounted() {
        
    },
    methods: {
        start() {
            Fetch('/user/myTeam').then((r) => {
                this.data = r.data;
                // this.teamList = r.data.top1;
                // if (r.data.top1.length == 0) {
                // 	this.listLength = true;
                // } else {
                // 	this.listLength = false;
                // }
                // this.countTop1 = r.data.top1.length;
                // this.countTop2 = r.data.top2.length;
                // this.countTop3 = r.data.top3.length;
                // this.countTeam = this.countTop1 + this.countTop2 + this.countTop3;
            });
        },
        copy() {
            this.$toast({
                className: "toastName",
                message: this.$t('invest_qrcode.copySucceeded'),
            });
        },
        copyCode() {
            navigator.clipboard.writeText(this.data.invitation_code).then(() => {
                this.$toast({
                    className: "toastName",
                    message: this.$t('invest_qrcode.copySucceeded'),
                });
            });
        },
        copyLink() {
            console.log(this.data,"11233");
            
            navigator.clipboard.writeText(this.data.share_link).then(() => {
                alert("推广链接复制成功");
            });
        }
    }
};
</script>

<style lang="less" scoped>
.container {
    max-width: 500px;
    height: 100vh;
    /* margin: 0 auto; */
    /* background: linear-gradient(180deg, #d82b2b 0%, #a41f1f 100%); */
    background-image: url(../images/user/rewardimg.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
    font-family: "微软雅黑", sans-serif;
    padding: 20px;
    border-radius: 12px;
    box-sizing: border-box;
}

.headers {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.logo {
    width: 24px;
    height: 24px;
    margin-right: 8px;
}

.title {
    font-size: 16px;
    font-weight: bold;
}

.main-title {
    font-size: 30px;
    color: #f3d99a;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
    text-shadow: 0 0 6px rgba(255, 255, 255, 0.6);
}

.invitation-code-box {
    display: flex;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 8px;
    padding: 12px;
    text-align: center;
    margin-bottom: 20px;
    
    .qrcode {
        object-fit: inherit;
        max-width: 100px !important;
        max-height: 100px !important;
        width: 100px !important;
        height: 100px !important;
    }

    .code-right {
        flex: 1;
    }
}

.code-left{
        width: 100px;
        height: 100px;
        /* overflow: hidden; */
    }

.code-display {
    width: 250px;
    padding: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: bold;
    /* margin-bottom: 12px; */
    letter-spacing: 4px;
}

.code-btn{
    display: flex;
    align-items: center;
    flex-direction: column;
}

.btn {
    background: #fff;
    color: #d82b2b;
    border: none;
    width: 75%;
    border-radius: 15px;
    padding: 8px 12px;
    margin: 5px 6px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.3s;
}

.btn:hover {
    background: #f0f0f0;
}

.rules,
.invite-friends {
    background: rgb(243 231 231);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
}

.rules h3,
.invite-friends h3 {
    /* margin-bottom: 12px; */
    font-weight: bold;
    font-size: 18px;
}

.rules ul,
.invite-friends ul {
    padding: 10px 0;
    list-style: none;
    padding-left: 0;
    font-size: 12px;
    line-height: 1.6;
    color: #000;

    li::marker {
        color: red;
        content: "●";
        padding: 5px;
    }
}

.invite-friends li {
    padding: 10px 0;
    border-bottom: 1px solid #cfcece;
}

.fontyc {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
}

.highlight {
    color: red;
    font-weight: bold;
}
</style>